import { AppCode } from 'data/records'
import { collection, resource, findSelector } from 'data/helpers/apiv3'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { OrderedSet, Map } from 'immutable'

const [api, actions] = resource(AppCode, [
  ['list', collection.get('', ['parentType', 'parentId'])],
  collection.post('bulkCreate', ['parentType', 'parentId', 'count'])
])

const selectors = {
  ...findSelector(AppCode),
  byExperienceId: (state, experienceId) => state.apiv3.appCode.id
    .filter(ac => ac.parentId === experienceId && ac.parentType === 'Experience' && ac.accessLimit !== null),
  allByExperienceId: (state, experienceId) => state.apiv3.appCode.id
    .filter(ac => ac.parentId === experienceId && ac.parentType === 'Experience')
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { parent_type: parentType, parent_id: parentId } = action.payload.meta
    const prevSlice = state.getIn(['byParent', parentType, parentId], OrderedSet())
    const acIds = OrderedSet(action.payload.results.map(r => r.id))
    return state.setIn(['byParent', parentType, parentId], prevSlice.concat(acIds))
  }
}

const initialState = {
  byParent: Map() // parentType -> parentId -> OrderedSet(AppCodeId)
}

export {
  api as appCodeApi,
  actions as appCodeActions,
  selectors as appCodeSelectors,
  reducers as appCodeReducers,
  initialState as appCodeInitialState
}
